// removed by extract-text-webpack-plugin
module.exports = {"heading":"AvatarModal__heading___14CCA","avatars":"AvatarModal__avatars___2VU-F","avatar":"AvatarModal__avatar___1IOrJ","chosen":"AvatarModal__chosen___ceFME"};


//////////////////
// WEBPACK FOOTER
// ./src/components/questions/AvatarModal.scss
// module id = 581
// module chunks = 1